import React from "react";
import { useParams } from "react-router-dom";

import Navbar from "../../../Navbar";
import Footer from "../../../Footer";

import "./BlogDetails.css";

import PreviewBlogPage from "../../../common/PreviewBlog";

const MemberTyp = localStorage.getItem("MemberType");

const BlogDetails = () => {
  const { name } = useParams();
  const parts = name.split("-");
  const id = parts.pop();

  return (
    <>
      <Navbar MemberType={MemberTyp} />
      <PreviewBlogPage userType="user" blogId={id} />
      {<Footer />}
    </>
  );
};

export default BlogDetails;
